import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { UnlockRateOptionsType } from '../pageShownCounters/enums';
interface IMeta {
  unlockRateOptions: {
    [pageShownCounter: number]: UnlockRateOptionsType;
  };
}
const initialState: IMeta = {
  unlockRateOptions: {},
};

const metaSlice = createSlice({
  name: 'meta',
  initialState,
  reducers: {
    enableAllRateOptions(state, action: PayloadAction<number>) {
      state.unlockRateOptions[action.payload] = UnlockRateOptionsType.ENABLE_ALL;
      return state;
    },
    disableRateOptions(state, action: PayloadAction<number>) {
      if (
        state.unlockRateOptions[action.payload] === undefined ||
        state.unlockRateOptions[action.payload] === UnlockRateOptionsType.DISABLE_ALL
      ) {
        state.unlockRateOptions[action.payload] = UnlockRateOptionsType.DISABLE_RATE_OPTIONS;
      }
      return state;
    },
    disableAllRateOptions(state, action: PayloadAction<number>) {
      if (state.unlockRateOptions[action.payload] === undefined) {
        state.unlockRateOptions[action.payload] = UnlockRateOptionsType.DISABLE_ALL;
      }
      return state;
    },
    forceDisableAllRateOptions(state, action: PayloadAction<number>) {
      state.unlockRateOptions[action.payload] = UnlockRateOptionsType.DISABLE_ALL;
      return state;
    },
  },
});

export const {
  enableAllRateOptions,
  disableRateOptions,
  disableAllRateOptions,
  forceDisableAllRateOptions,
} = metaSlice.actions;
const metaReducer = metaSlice.reducer;
export default metaReducer;
